<template>
    <div class="equipment_library_wrap">
        <div class="header">
            <el-col :span="19">
                <el-button
                    type="primary"
                    size="medium"
                    @click="gotoAdd"
                >设备入库
                </el-button>
                <el-button
                    type="primary"
                    size="medium"
                    @click="exportEquipmentLibraryList"
                >导出设备二维码
                </el-button>
                <!-- <label class="control-label">设备类型：</label> -->
                <el-select
                    size="medium"
                    v-model="listQuery.equipType"
                    placeholder="请选择设备类型"
                    @change="changeType"
                >
                    <el-option
                        v-for="item in typeList"
                        :key="item.code"
                        :label="item.value"
                        :value="item.code"
                    ></el-option>
                </el-select>
                <!-- <label class="control-label">设备用途：</label> -->
                <template v-if="listQuery.equipType != 10004 &&listQuery.equipType != 10005 && listQuery.equipType != 10006">
                    <el-select
                        size="medium"
                        v-model="listQuery.useType"
                        placeholder="请选择设备用途"
                        @change="handleFilter"
                    >
                        <el-option
                            :key="-1"
                            label="全部用途"
                            :value="0"
                        ></el-option>
                        <el-option
                            v-for="item in useTypeList"
                            :key="item.code"
                            :label="item.value"
                            :value="item.code"
                        ></el-option>
                    </el-select>
                    <!-- <label class="control-label">设备状态：</label> -->
                    <el-select
                        size="medium"
                        v-model="listQuery.status"
                        placeholder="请选择设备状态"
                        @change="handleFilter"
                    >
                        <el-option
                            label="全部状态"
                            value="0"
                        ></el-option>
                        <el-option
                            label="离线"
                            value="1"
                        ></el-option>
                        <el-option
                            label="在线"
                            value="2"
                        ></el-option>
                    </el-select>
                </template>

            </el-col>
            <el-col :span="5">
                <el-input
                    size="medium"
                    placeholder="请输入设备号"
                    v-model.trim="listQuery.equipmentIdNew"
                    @change="handleFilter"
                >
                    <el-button
                        size="medium"
                        slot="append"
                        icon="el-icon-search"
                        @click="handleFilter"
                    ></el-button>
                </el-input>
            </el-col>
        </div>
        <el-table
            stripe
            :data="dataList"
            :height="`${windowHeight - 210}px`"
            border
            style="width: 100%"
        >
            <el-table-column
                label="设备号"
                prop="equipmentId"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="所属学校"
                align="center"
                prop="schoolName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="设备类型"
                align="center"
                prop="equipTypeName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="型号"
                align="center"
                prop="moduleName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="设备用途"
                align="center"
                prop="useTypeName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="设备状态"
                align="center"
            >
                <template slot-scope="scope">
                  <span v-if="scope.row.state==2">
                    <el-tag size="mini"
                        v-if="scope.row.status==2"
                        type="success"
                    >在线</el-tag>
                    <el-tag size="mini"
                        v-else-if="scope.row.status==1"
                        type="warning"
                    >离线</el-tag>
                  </span>
                    <span v-else>
                        <el-tag type="danger" size="mini">未绑定</el-tag>
                      </span>
                </template>
            </el-table-column>

            <el-table-column
                label="更新时间"
                align="center"
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.updateTime"> {{scope.row.updateTime | timeFormat}}</span>
                    <span v-else>{{scope.row.createTime | timeFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
            >
                <template slot-scope="scope">
                    <!-- <el-button
                      type="text"
                      @click="gotoEdit(scope.row)"
                    >编辑</el-button> -->
                    <el-button
                        type="text"
                        @click="handleLookOver(scope.row)"
                    >二维码
                    </el-button>
                    <el-button
                        type="text"
                        v-if="scope.row.state != 2"
                        @click="handleDelete(scope.row)"
                    >删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>

        <el-dialog
            title="二维码"
            :visible.sync="dialogVisible"
            width="30%"
        >
            <div style="text-align: center;">
                <img :src="qrCodeUrl">
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        findDicsByCode,
        subFindDicsByCode,
        getEquipmentLibraryPage,
        delEquipmentLibrary,
        exportEquipmentLibraryList,
    } from "@/api/equipmentLibrary";
    import windowResize from "@/mixins/windowResize";

    export default {
        name: "equipmentLibraryIndex",
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    equipType: "",
                    equipmentIdNew: "",
                    status: "0",
                    useType: 0,
                    moduleId: '',
                    schoolName: '',
                },
                dataList: [],
                total: null,
                typeList: [],
                useTypeList: [],
                dialogVisible: false,
                qrCodeUrl: "",
                exportUrl: "",
            };
        },
        filters: {
            timeFormat(time) {
                return time ? time.substring(0, 19) : "--";
            },
        },
        created() {
            this.findDicsByCodes();
        },
        activated() {
            this.findDicsByCodes();
        },
        mixins: [windowResize],
        methods: {
            exportEquipmentLibraryList() {
                exportEquipmentLibraryList()
                    .then((res) => res.data)
                    .then((data) => {
                        if (data.result) {
                            const prefixUrl =
                                global.command === "production"
                                    ? "https://www.zhxiaoyuan.cn/"
                                    : "http://api.weixiaojia.net/";
                            window.open(
                                `${prefixUrl}thunder/archive/getArchiveByKey?archiveName=${data.data.zipName}&key=${data.data.key}&token=${this.$store.getters.token}`,
                                "_blank"
                            );
                        }
                    });
            },

            //获取类型
            findDicsByCodes() {
                findDicsByCode().then((res) => {
                    let data = res.data.data;
                    this.typeList = data;
                    this.listQuery.equipType = data[0].code;
                    this.subFindDicsByCode();
                });
            },
            subFindDicsByCode() {
                if(this.listQuery.equipType == 10004 ||this.listQuery.equipType == 10005 || this.listQuery.equipType == 10006) {
                    this.getList();
                } else {
                    subFindDicsByCode({
                        dicCode: this.listQuery.equipType,
                    }).then((res) => {
                        let data = res.data.data;
                        this.useTypeList = data;
                        this.getList();
                    });
                }

            },
            //获取列表
            getList() {
                getEquipmentLibraryPage(this.listQuery)
                    .then((res) => res.data)
                    .then((data) => {
                        this.dataList = data.data.dataList;
                        this.total = data.data.pagination.total;
                    })
                    .catch((err) => {
                    });
            },
            delEquipmentLibrary(form) {
                delEquipmentLibrary(form).then((res) => {
                    this.$message({
                        message: "删除成功",
                        type: "success",
                    });
                    this.getList();
                });
            },
            handleDelete(item) {
                this.$confirm("此操作将删除此设备, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.delEquipmentLibrary({
                            equipType: item.equipType,
                            equipmentId: item.equipmentId,
                        });

                    })
                    .catch(() => {
                    });
            },
            //搜索
            changeType() {
                this.listQuery.status = "0";
                this.subFindDicsByCode();
            },
            //搜索
            handleFilter() {
                this.listQuery.pageNo = 1;
                this.getList();
            },
            //切换码数
            handleSizeChange(val) {
                this.listQuery.pageNo = 1;
                this.listQuery.pageSize = val;
                this.getList();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.getList();
            },

            gotoAdd() {
                this.$router.push({
                    path: "form",
                });
            },
            gotoEdit(item) {
                this.$router.push({
                    path: "form",
                    query: {
                        scanId: item.id,
                    },
                });
            },

            handleLookOver(item) {
                console.log(item);
                this.qrCodeUrl = item.qRCodeUrl;
                this.dialogVisible = true;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .equipment_library_wrap {
        padding: 12px;

        .header {
            padding-bottom: 10px;
            overflow: hidden;
        }

        .el-select {
            width: 150px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/hardwareManage/equipmentLibraryIndex.vue